import { NumberValue } from '../../../utils'

export const getTotalAmount = (unitPrice: number | string, quantity: number) =>
  new NumberValue(unitPrice).multiply(quantity).getRounded()
